import { css } from '@emotion/react';
import { useTooltip, Text, FontWeight } from '@frontend/design-system';

type AlternativePayerIdsProps = {
  payerIds: string[];
  weight?: FontWeight;
};

export const AlternativePayerIds = ({ payerIds, weight = 'bold' }: AlternativePayerIdsProps) => {
  const { triggerProps, Tooltip, tooltipProps } = useTooltip({
    placement: 'right',
  });

  if (!payerIds.length) return '-';

  const value = payerIds?.join(',\n');

  return (
    <>
      <Text {...triggerProps} as='dd' weight={weight} size='medium' css={textStyles}>
        {value}
      </Text>
      <Tooltip {...tooltipProps}>
        <div css={{ whiteSpace: 'pre-wrap', fontWeight: 'normal' }}>{value}</div>
      </Tooltip>
    </>
  );
};

const textStyles = css({ whiteSpace: 'nowrap', width: 'fit-content', overflow: 'hidden', textOverflow: 'ellipsis' });
